import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'
import { findMinInsuredObjectTotalPremiumValue } from './Prices'

export const useTotalPriceAnimalsInstallment = () => {
  const { typeOfPrice } = useSimulatorStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()

  const _animalList =
    runPetisSimulation?.runPetisSimulationResponse?.insuredObjectGroup
      ?.insuredObjects

  const handleTotalPriceAnimalsInstallment = (packId: string) => {
    return (
      _animalList?.reduce(
        (acc, animal) =>
          acc +
          findMinInsuredObjectTotalPremiumValue(
            animal?.packsObject?.packs
              ?.find((pack) => pack.packId === packId)
              ?.premiums?.filter(
                (premium) => premium.installment === typeOfPrice,
              ) || [],
          ),
        0,
      ) || 0
    )
  }

  const handleTotalPriceAnimalsInstallmentAllPremiums = (packId: string) => {
    return _animalList?.reduce(
      (acc, animal) =>
        acc +
        findMinInsuredObjectTotalPremiumValue(
          animal?.packsObject?.packs?.find((pack) => pack.packId === packId)
            ?.premiums || [],
        ),
      0,
    )
  }

  return {
    handleTotalPriceAnimalsInstallment,
    handleTotalPriceAnimalsInstallmentAllPremiums,
  }
}
